import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

export type TelegramChat = components["schemas"]["TelegramChat"];

/**
 * Detects the Telegram group chats the bot can currently see (the BE performs a
 * read-only getUpdates peek). Triggered imperatively from a button, so it is a
 * mutation: `detect.mutate(undefined, { onSuccess, onError })`. Deliberately not
 * cached — each detection is a fresh, time-sensitive peek (Telegram's ~24h
 * update retention window).
 */
export function useDetectTelegramChats() {
  return useMutation({
    // Component owns all error toasts (503→warn, 409/other→error); suppress the global handler.
    meta: { silentError: true },
    mutationFn: async () => {
      const { data, error } = await apiClient.GET("/v1/notifications/telegram/chats");
      if (error) throw error;
      return data;
    },
  });
}
